/*
 * 把引擎中的组件包装为 Formily 自定义组件（MwHeader / MwMiddle / MwMiddleDg / MwFooter / MwDgParallel）
 * - schema 中声明为非 void 字段（type: "string"），不需要 decorator
 * - 字段校验器调用组件自身校验，失败时根节点带 validatestatus="error"，供平台提交时滚动定位
 */
import { defineComponent, h, onMounted, onBeforeUnmount, getCurrentInstance } from "vue-demi";
import { useField, useForm } from "@formily/vue";
import { reaction } from "@formily/reactive";
import { getEngine, releaseEngine } from "./engine";
import "./styles/icons.css";
import "./styles/base.css";
import "./styles/header.css";
import "./styles/middle.css";
import "./styles/middle_dg.css";
import "./styles/footer.css";
import "./styles/parallel_dg.css";

export default function createPart(name, componentName, platform) {
  return defineComponent({
    name: componentName,
    setup() {
      const fieldRef = useField();
      const formRef = useForm();
      const vm = getCurrentInstance();
      let field, form, part, MW, dispose;

      onMounted(() => {
        field = fieldRef.value;
        form = formRef.value;
        const el = (vm.proxy || vm).$el;
        if (!field || !form || !el) return;
        MW = getEngine(form, platform);
        MW.fields.push(field);
        part = MW.parts[name];
        // 中部组件在引擎启动（回填流程变量）前声明自己的适配器，头尾组件据此判断检查清单状态
        if (part.middle) MW.biz.useMiddle(part.middle);
        part.placeholder(el);
        field.setValidator(() => {
          const errs = part.el ? part.validate() : [];
          el.setAttribute("validatestatus", errs.length ? "error" : "success");
          if (errs.length) {
            MW.reportErrors();
            return part.title + "还有 " + errs.length + " 项未完成";
          }
          return "";
        });
        MW.start().then(() => {
          if (part && field) part.mount(el);
        });
        // 禁用 / 只读状态变化时重绘
        dispose = reaction(
          () => field.pattern,
          () => MW.store.touch()
        );
      });

      onBeforeUnmount(() => {
        dispose && dispose();
        part && part.unmount();
        if (form && field) releaseEngine(form, field);
        field = null;
      });

      return () => h("div", { class: "mw-scope mw-root mw-root--" + name });
    },
  });
}
